module.exports = __webpack_public_path__ + "img/Cerrar_overlay.9ff682db.svg";